import { PayloadAction } from '@reduxjs/toolkit'
import i18next from 'i18next'
import last from 'lodash/last'
import { resetAllState } from '@/store/commonActions.ts'
import { createAppSlice } from '@/store/createAppSlice.ts'

interface LoadingItem {
  id: string
  message?: string
  modal?: boolean
}

interface LoadingSliceState {
  stack: LoadingItem[]
}

const initialState: LoadingSliceState = {
  stack: [],
}

export const loadingSlice = createAppSlice({
  extraReducers(builder) {
    builder.addCase(resetAllState, () => initialState)
  },
  initialState,
  name: 'loading',
  reducers: (create) => ({
    push: create.reducer((state, action: PayloadAction<LoadingItem>) => {
      const fallbackMessage = i18next.isInitialized
        ? i18next.t('common.loading')
        : ''

      state.stack.push({
        ...action.payload,
        message: action.payload.message || fallbackMessage,
      })
    }),
    remove: create.reducer((state, action: PayloadAction<string>) => {
      state.stack = state.stack.filter(({ id }) => id !== action.payload)
    }),
  }),
  selectors: {
    isModal: (state): boolean => {
      const lastItem = last(state.stack)
      if (!lastItem) {
        return false
      }

      return lastItem.modal ?? true
    },
    loadingMessage: (state) => {
      const lastItem = last(state.stack)
      return lastItem ? lastItem.message : null
    },
  },
})
